/* eslint-disable guard-for-in */
/* eslint-disable max-depth */
import { useAuth0 } from '@auth0/auth0-react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAppSelector } from '../redux/hooks';
import ROLES, { rolesArray } from '../utils/roles';
import _ from 'lodash';
import { isMobile } from './helpers';
import { useDispatch } from 'react-redux';
import { makeStyles } from '@mui/styles';
import AppLoader from '../components/AppLoader';
import ErrorPage from '../components/ErrorPage';
import { Box, Dialog, Typography, LinearProgress } from '@mui/material';
import EditProfileForm from '../pages/new-designs/components/EditProfileForm';
import HobbiesForm from '../pages/new-designs/components/HobbiesForm';
import SocialHandlesForm from '../pages/new-designs/components/SocialHandlesForm';
import DisabilityForm from '../pages/new-designs/components/DisabilityForm';
import DigitalIntroForm from '../pages/new-designs/components/DigitalIntroForm';
import EducationForm from '../pages/new-designs/components/EducationForm';
import WorkHistoryForm from '../pages/new-designs/components/WorkHistoryForm';
import useProfileDetails from '../hooks/useProfileDetails';
import DosenDarkLogoImport from '../assets/images/brand/dosen/dark-logo.png';
import OnboardingQuestions from '../pages/new-designs/components/OnboardingQuestions';
import { AGILE_ORG, RDP_CREATIVE } from '../utils/constants';
import useResponsiveScreenSwitch from '../utils/useResponsiveScreenSwitch';
import OnboardingProcessNew from '../pages/new-designs/tabs/profile/OnboardingProcessNew';
import useOrgSettings from '../hooks/useOrgSettings';
import OnboardingProcessIndustry from '../pages/new-designs/tabs/profile/OnboardingProcessIndustry';
import { popupCountActions } from '../redux/slices/poupsCountsSlice';
import Company from '../pages/new-designs/components/Company';
import CompanyPosition from '../pages/new-designs/components/CompanyPosition';
import CompanyInformation from '../pages/new-designs/components/CompanyInformation';
import LearningObjectives from '../pages/new-designs/tabs/profile/OnboardingLearningObjectives';

const useStyles = makeStyles({
  logoBox: {
    textAlign: 'left',
    paddingTop: '20px',
    paddingBottom: '20px',
    '@media (min-width: 600px)': {
      textAlign: 'center',
      paddingBottom: '40px'
    }
  }
});

const Redirect = () => {
  const { isAuthenticated, isLoading, error } = useAuth0();
  const classes = useStyles();
  const count = useAppSelector((state) => state.popupsCount.count);
  const { loading, data } = useAppSelector((state) => state.mentorTasks);
  const user = useAppSelector((state) => state.userProfile);
  let role = localStorage.getItem('role') || '';
  const isAuth = localStorage.getItem('isAuthenticated');
  const isLoggedIn = isAuth ? JSON.parse(isAuth) : false;
  const { ftue, mentee, mentors } = useProfileDetails();
  const { settings, firstName, category, lastseen } = useProfileDetails() || {
    settings: { disabilityType: undefined }
  };

  const selectedGroupId = useAppSelector((state) => state.selectedGroup.data);
  const isMentor = lastseen?.role === 'mentor';
  const isMentee = lastseen?.role === 'mentee';
  // console.log('settings', settings);
  const oid = useAppSelector((state) => state.orgDetails.data?.oid);
  const { forMobile } = useResponsiveScreenSwitch();
  const dispatch = useDispatch();

  interface Popup {
    component: React.ReactNode;
    name: string;
    heading: string;
    subHeading?: string;
  }

  const isOrgSettings = useOrgSettings();
  /** Profile Information */
  const newPopups: Popup[] = [
    {
      component: <EditProfileForm />,
      name: 'Profile Information',
      heading: 'Profile Information'
    }
  ];

  if (settings?.videoIntro !== undefined) {
    newPopups.push({
      component: <DigitalIntroForm />,
      name: 'Video Intro',
      heading: 'Video Intro'
    });
  }

  /** Basic setting to selected field */
  if (isOrgSettings) {
    /** Company Form */
    if (settings?.companyName !== undefined) {
      newPopups.push({
        component: <Company />,
        name: 'Company',
        heading: 'Company',
        subHeading: "Add the company you're joining your program with"
      });
    }

    /** Company Information */
    if (settings?.companyInfo !== undefined) {
      newPopups.push({
        component: <CompanyInformation />,
        name: 'Company Information',
        heading: 'Company Information',
        subHeading: "Add the company you're joining your program with"
      });
    }

    /** Company Position Form */
    if (settings?.companyPosition !== undefined) {
    newPopups.push({
      component: <CompanyPosition />,
      name: 'Company Position',
      heading: 'Company Position',
    });
  }

    /** Learning Objectives */
    if (settings?.learningObjectives !== undefined && (isMentor || isMentee)) {
      newPopups.push({
        component: <LearningObjectives />,
        name: `${isMentor ? 'Areas of Expertise' : 'Learning Objectives'}`,
        heading: `${isMentor ? 'Areas of Expertise' : 'Learning Objectives'}`,
        subHeading: `${
          isMentor
            ? 'Select the areas in which you can help members of this program'
            : 'Your organization would like you to complete the following number of objectives from their list as part of your program'
        }`
      });
    }

    /** Social handles */
    if (settings?.socials !== undefined) {
      newPopups.push({
        component: <SocialHandlesForm />,
        name: 'Social Handles',
        heading: 'Social Handles'
      });
    }

    /** Hobbies Form */
    if (oid !== AGILE_ORG && settings && settings.hobbiesInterests !== undefined) {
      newPopups.push({
        component: <HobbiesForm />,
        name: 'Hobbies and interests',
        heading: 'Hobbies and Interests'
      });
    }

    /** Topics & Industry */
    //  if ((mentee.length > 0 || mentors.length > 0) && oid !== RDP_CREATIVE && settings && settings.topics!== undefined ) {
    //   newPopups.push({
    //     component: <OnboardingProcessNew />,
    //      name: 'Select the topics most relevant to you',
    //      heading: 'Select the topics most relevant to you'
    //    });
    //   }
    //   if ((mentee.length > 0 || mentors.length > 0) && oid !== RDP_CREATIVE  && settings && settings.industries!== undefined ){
    //    newPopups.push({
    //     component: <OnboardingProcessIndustry />,
    //     name: 'Select the industries most relevant to you',
    //      heading: 'Select the industries most relevant to you'
    //    });
    //  }

    if (
      (mentee.length > 0 || mentors.length > 0) &&
      oid !== RDP_CREATIVE &&
      settings &&
      settings.subjects !== undefined
    ) {
      newPopups.push({
        component: <OnboardingProcessNew />,
        name: 'Select the topics most relevant to you',
        heading: 'Select the topics most relevant to you'
      });
      newPopups.push({
        component: <OnboardingProcessIndustry />,
        name: 'Select the industries most relevant to you',
        heading: 'Select the industries most relevant to you'
      });
    }

    /** Education Form */
    if (oid !== AGILE_ORG && settings && settings.educationHistory !== undefined) {
      newPopups.push({
        component: <EducationForm />,
        name: 'Education History',
        heading: 'Education History'
      });
    }

    /** Work History Form */
    if (settings && settings.workHistory !== undefined) {
      newPopups.push({
        component: <WorkHistoryForm />,
        name: 'Work History',
        heading: 'Work History'
      });
    }

    /** Disability Form */
    if (settings?.disabilityType !== undefined) {
      newPopups.push({
        component: <DisabilityForm />,
        name: 'Disability',
        heading: 'Disability'
      });
    }

    /** Onboarding Questions */
    if (data?.data?.length > 0) {
      newPopups.push({
        component: <OnboardingQuestions />,
        name: 'Assement',
        heading: 'Assesment'
      });
    }
  }

  let totalSteps: any = newPopups.length;
  dispatch(popupCountActions.setPopupLength(newPopups.length));
  const showPopups = () => {
    return (
      <Dialog
        open={ftue}
        onClose={() => {}}
        aria-labelledby="onboardingProcess-dialog-title"
        aria-describedby="onboardingProcess-dialog-description"
        disableEnforceFocus
        fullWidth
        fullScreen={forMobile}
        BackdropProps={{
          sx: { backgroundColor: '#F9FAFC' }
        }}
        PaperProps={{
          sx: {
            padding: '20px',
            boxShadow: 'none',
            border: '1px solid #EFF0F4',
            height: '100%',
            '@media (max-width: 600px)': {
              margin: '0px',
              maxWidth: 'calc(100% - 0px) !important',
              width: '100%',
              padding: '0px',
              height: '100%'
            }
          }
        }}
      >
        <Box px={2}>
          <Box className={classes.logoBox}>
            <img alt="" width="130" src={DosenDarkLogoImport} />
          </Box>
          <LinearProgress
            color="success"
            variant="determinate"
            value={(count / (totalSteps + (data?.data?.length > 0 ? data?.data?.length - 1 : 0))) * 100}
          />
          <Box textAlign="right" mt={forMobile ? '-35px' : 1} mb={1}>
            {isOrgSettings ? (
              <Typography variant="h6">{`Step ${count + 1} of ${
                totalSteps + (data?.data?.length > 0 ? data?.data?.length - 1 : 0)
              }`}</Typography>
            ) : (
              <Typography variant="h6">Step 1 of 1</Typography>
            )}
          </Box>
        </Box>
        {/* hiding the heading from onboarding onwards as every question has it's onw heading */}
        {!isOrgSettings ? (
          <Box px={2} pt={2}>
            <Typography variant="h2">{newPopups[count]?.heading}</Typography>
          </Box>
        ) : (
          count < newPopups.length && (
            <Box px={2} pt={2}>
              <Typography variant="h2">{newPopups[count]?.heading}</Typography>
            </Box>
          )
        )}

        {/* Sub Heading */}
        {newPopups[count]?.subHeading?.trim() && (
          <Typography mt={'5px'} px={2} fontSize={'12px'} fontStyle={'italic'}>
            {newPopups[count]?.subHeading}
          </Typography>
        )}

        {/* the last step is onboarding questions, so only one component(OnboardingQuestions) is displayed and steps are managed inside it */}
        {!isOrgSettings ? (
          newPopups[count]?.component
        ) : count >= newPopups.length ? (
          <OnboardingQuestions />
        ) : (
          newPopups[count]?.component
        )}
      </Dialog>
    );
  };

  /** Check user type */
  const checkUserProfile = () => {
    if (isMobile()) {
      return <Navigate to="/comingsoon" />;
    }
    if (role && rolesArray.includes(role)) {
      // to get the no of steps we need the response, that's why loader added for tasks
      if (user.loading || (ftue && loading)) return <AppLoader />;
      if (user.error) return <ErrorPage message={user.errorText} />;
      if (user.data) {
        if (role !== ROLES.platAdmin && ftue) {
          // console.log('ftue', ftue);
          if (role === ROLES.orgAdmin && !isOrgSettings && firstName !== '') {
            return <Navigate to="/redirect" />;
          }
          return showPopups();
        } else {
          return <Navigate to="/redirect" />;
        }
      }
    }
    if (role && !rolesArray.includes(role)) {
      return <ErrorPage message="This member does not have a role associated" />;
    }
    // if (user.data) return <h1>Done</h1>;
    // return <ErrorPage message="Something went wrong, please try again" />;
    return null;
  };

  /** Loader */
  if (isLoading) return <AppLoader />;
  // if (error) return <ErrorPage message={error.message}/>;

  if (error) {
    if (error.message === 'the specified account is not allowed to accept the current invitation') {
      return <ErrorPage message="You can only activate your account with the email address used on your invitation" />;
    } else {
      return <ErrorPage message={error.message} />;
    }
  }

  const mobileAppLinkPage = localStorage.getItem('mobileAppLinkPage');
  const invitation = localStorage.getItem('invitation');

  // if (mobileAppLinkPage !== 'true' && isMobile() && (!invitation || (isAuth && ftue))) {
  //   return <Navigate to="/download-app" />;
  // }
  if (isAuthenticated || isLoggedIn) return checkUserProfile();
  return <Navigate to="/login" replace={true} />;
};

export default Redirect;
